// Static site content for G&F Customs.
//
// Voice: a luxury retail environment practice, not a fabrication shop. Avoid
// trade-shop framing ("we build", "our workshop") that positions the studio as
// a subcontractor rather than a brand partner.
//
// CLIENTS below is the roster confirmed by the studio. Project captions, by
// contrast, describe only what is visible in G&F's own photography — a photo is
// never captioned with a brand it does not show.

export const BRAND = {
  name: "G&F Customs",
  full: "Giovanni & Francesco",
  discipline: "Luxury Retail Environments",
  location: "Toronto, Ontario",
  corridor: "Toronto → North America",
};

export const CONTACT = {
  phone: "647 761 4168",
  phoneTel: "+16477614168",
  email: "gandfcustoms@gmail.com",
  whatsapp: "https://api.whatsapp.com/send?phone=16477614168",
  location: "Toronto, Ontario, Canada",
  instagram: "https://www.instagram.com/gandfcustoms/",
  note: "Commercial enquiries only",
};

export const NAV_LINKS = [
  { label: "Work", href: "#work" },
  { label: "Capabilities", href: "#capabilities" },
  { label: "Our Standard", href: "#standard" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
];

export const HERO = {
  line1: "The physical",
  line2: "expression of luxury.",
  body: "We execute retail environments for the world's most iconic brands.",
  cta: "Explore our work",
  src: "/img/work/detail-02.jpg",
  credit: ["Salvatore Ferragamo", "Yorkdale, Toronto"],
};

// Roster confirmed by the studio.
export const CLIENTS = [
  "Louis Vuitton",
  "Prada",
  "Dior",
  "Tiffany & Co.",
  "Rolex",
  "Loewe",
  "Hermès",
  "Ferragamo",
];

const W = "/img/work";

export const CAPABILITIES = [
  {
    title: "Storefronts",
    lines: ["Exterior identity.", "Entrances.", "Facades."],
    src: `${W}/detail-02.jpg`,
    alt: "Illuminated stone storefront facade with recessed vertical light strips and a warm-fin entry portal",
  },
  {
    title: "Window Campaigns",
    lines: ["Seasonal rollouts.", "Visual merchandising.", "Campaign installation."],
    src: `${W}/detail-01.jpg`,
    alt: "Display vitrine with polished chrome armature and floating trays against a sheer curtain field",
  },
  {
    title: "Interiors",
    lines: ["Fixtures.", "Stone, metal, timber.", "Displays."],
    src: `${W}/vitrine.jpg`,
    alt: "Retail interior with illuminated wall cases, display tables and suspended fabric lightboxes",
  },
  {
    title: "Retail Care",
    lines: ["Maintenance.", "Refreshes.", "Emergency response."],
    src: `${W}/loccitane.jpg`,
    alt: "Retail interior with wall systems, a stone service bar and curved banquette seating",
  },
  {
    title: "Brand Experience",
    lines: ["Product launches.", "Activations.", "Flagship moments."],
    src: `${W}/luciforma.jpg`,
    alt: "Flagship interior with mirror-polished arches, a suspended floral canopy and lit display islands",
  },
];

export const STANDARD_BAND = {
  title: "Luxury is in the details.",
  lines: [
    "Millimetre precision.",
    "Flawless execution.",
    "Complete discretion.",
  ],
  kicker: "That's our standard.",
  src: `${W}/detail-03.jpg`,
  alt: "Close detail of a luxury display vitrine with chrome armature and seasonal product staging",
};

// Captions describe only what each photograph shows.
export const FEATURED = [
  {
    src: `${W}/detail-03.jpg`,
    client: "Salvatore Ferragamo",
    location: "Yorkdale, Toronto",
    title: "Luxury window installation",
    alt: "Salvatore Ferragamo window vitrine with mannequin, chrome armature and butterfly display scheme",
  },
  {
    src: `${W}/luciforma.jpg`,
    client: "L'Occitane en Provence",
    location: "Yorkdale, Toronto",
    title: "Flagship interior & display",
    alt: "L'Occitane flagship interior with polished arches, floral ceiling canopy and curved display islands",
  },
  {
    src: `${W}/vitrine.jpg`,
    client: "Optical retail",
    location: "Toronto, Ontario",
    title: "Interior fixtures & lighting",
    alt: "Optical retail interior with illuminated wall cases, timber display tables and suspended lightboxes",
  },
];

export const PRINCIPLES = [
  { title: "Precision", lines: ["Millimetre-perfect", "execution in every detail."] },
  { title: "Craftsmanship", lines: ["Delivered with the", "finest materials."] },
  { title: "Discretion", lines: ["Trusted by luxury brands", "for confidential projects."] },
  { title: "Reliability", lines: ["Installed on schedule.", "Finished without compromise."] },
  { title: "Consistency", lines: ["Global standards.", "Local excellence."] },
];

export const ABOUT = {
  eyebrow: "About",
  title: "Giovanni & Francesco",
  body: [
    "G&F Customs is a Toronto studio working exclusively in luxury retail environments.",
    "We are engaged by fashion houses, jewellers and hospitality groups to take a brand's intent and resolve it into a physical environment — one that holds under raking light, at eye level, for a full season.",
    "Concept development, technical resolution, delivery and installation. One accountable party from the first drawing to the night the doors open.",
  ],
  points: [
    ["Base", "Toronto, Ontario"],
    ["Delivering", "Canada & United States"],
    ["Install window", "Off-hours & overnight"],
    ["Engaged by", "Brand VM, store development, retail architects"],
  ],
};

export const CTA = {
  title: "Let's build the next flagship.",
  corridor: "Toronto → North America",
  action: "Start a project",
};

export const PROJECT_TYPES = [
  "Storefront",
  "Window campaign",
  "Interior",
  "Retail care",
  "Brand experience",
];
